export function alterar_mascara(personalidade) {
    let isCpfReadonly = true;
    let isFantasiaReadonly = true;
  
    if (personalidade === 'PF') {
      isCpfReadonly = false;
      isFantasiaReadonly = true;
    } else if (personalidade === 'PJ') {
      isCpfReadonly = false;
      isFantasiaReadonly = false;
    }
  
    return {
      isCpfReadonly,
      isFantasiaReadonly
    };
  }
  
